"use client";
import React from "react";
import styles from "./MeetTeam.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
  faCloud, 
  faCogs, 
  faServer, 
  faShieldAlt, 
  faHeadset, 
  faLightbulb 
} from "@fortawesome/free-solid-svg-icons";

const MeetTeam = () => {
  const teamItems = [
    { icon: faCloud, title: "Cloud<br/>Architects" },
    { icon: faCogs, title: "System<br/>Engineers" },
    { icon: faServer, title: "DevOps<br/>Experts" },
    { icon: faShieldAlt, title: "Security<br/>Specialists" },
    { icon: faHeadset, title: "Customer Support<br/>Professionals" },
    { icon: faLightbulb, title: "Product<br/>Innovators" },
  ];

  return (
    <div className="bg-dark py-5">
      <div className="container text-center">
        <h4 className="text-white mb-2">Meet the Team</h4>
        <p className="text-white opacity-75 mb-4">
          Behind Temok is a powerhouse of:
        </p>

        <div className="row g-4 justify-content-center">
          {teamItems.map((item, index) => (
            <div className="col-lg-2 col-md-3 col-6" key={index}>
              <div className={styles.TeamBox}>
                
                <div className={styles.IconWrap}>
                  <FontAwesomeIcon icon={item.icon} />
                </div>

                <h6
                  dangerouslySetInnerHTML={{ __html: item.title }}
                ></h6>

              </div>
            </div>
          ))}
        </div>

        <p
          className="text-white opacity-75 mt-4"
          style={{ maxWidth: "720px", margin: "0 auto" }}
        >
          With years of industry experience and a passion for technology, our
          team brings together the skill, dedication, and vision that Temok
          stands for.
        </p>
      </div>
    </div>
  );
};

export default MeetTeam;
